import { Box, Typography } from "@mui/material";
import type { Theme } from "../../constants/themeConstants";
import styled from "styled-components";

export const AsideNavContainer = styled(Box)`
  background: ${({ theme }) => (theme as Theme).colors.dark}0d;
  border-left: 4px solid ${({ theme }) => (theme as Theme).colors.secondary};
  width: 100%;
  max-width: 368px;

  gap: 18px;
  padding: 32px 24px 32px 32px;

  font-size: 16px;

  .MuiListItem-root {
    padding: 9px 0;
    a:hover {
      color: ${({ theme }) => (theme as Theme).colors.hoverTextColor};
    }
  }

  .MuiListItem-root {
    padding: 18px 8px 0 12px;

    font-family: Roboto;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
  }

  @media (max-width: 768px) {
    max-width: fit-content;
  }
`;

export const AsideNavTitle = styled(Typography)`
  && {
    padding: 0 8px 0 12px;

    font-family: Roboto;
    font-weight: 700;
    font-size: 24px;
    line-height: 110.00000000000001%;
    letter-spacing: 0%;
  }
`;
